import { useState } from "react";
import personalBestBg from "../../Assets/Images/header-background.png";

export default function SkillCard({
  unit,
  backgroundImage,
  gameImage,
  ballerzGameName,
  esaIsHitMiss,
  hit,
  miss,
  scoreDisplay,
  best,
  previous,
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <a className="bg-[#010058] rounded-md overflow-hidden shadow-lg text-white font-sans">
        <div className="relative">
          <div className="h-[10px] w-full bg-[#010058] rounded-t-md"></div>

          <div
            className="h-32 relative z-10 px-4 py-3"
            style={{
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* <a
              onClick={() => alert("Share button clicked!")}
              className="absolute top-3 right-4 flex items-center gap-1 text-white text-sm cursor-pointer"
            >
              Share
              <img
                className="w-4 h-4"
                src={require(`./assets/share.png`)}
                alt="share icon"
              />
            </a> */}

            <svg
              viewBox="0 0 100 40"
              preserveAspectRatio="none"
              className="absolute bottom-0 left-0 w-[40%] h-[40px] text-[#00001d]"
            >
              <path d="M0,0 C100,0 60,40 100,40 L0,40 Z" fill="currentColor" />
            </svg>
          </div>
        </div>

        <div className="h-[100px] flex items-start justify-between bg-[#00001d] px-4 relative overflow-visible">
          <div className="text-left max-w-[55%] mt-2">
            <div className="text-sm font-bold tracking-wide leading-tight">
              <img
                className="w-[45%] h-[45%] object-contain"
                src={gameImage}
                alt="logo"
              />
            </div>
            <div
              className={`text-xs text-[#4F83FF] uppercase mb-2 ${
                ballerzGameName === "Basket" ||
                gameImage ===
                  "https://app.ballerz.co.uk/assets/portal/icon/tiki-taka.png"
                  ? "mt-2"
                  : gameImage ===
                    "https://app.ballerz.co.uk/assets/portal/icon/sharpshooter.png"
                  ? "mt-0"
                  : "mt-6"
              } Kallisto_Bold`}
            >
              {ballerzGameName}
            </div>
          </div>

          <div className="text-right relative z-10">
            {esaIsHitMiss === 0 ? (
              <div className="absolute -top-10 right-0 text-9xl font-extrabold leading-none DrukWideMediumItalic">
                {scoreDisplay}
              </div>
            ) : (
              <>
                <div
                  className="absolute -top-10 right-20 text-9xl font-extrabold leading-none DrukWideMediumItalic"
                  style={{
                    WebkitTextStroke: "2px green",
                    color: "white",
                  }}
                >
                  {hit}
                </div>
                <div
                  className="absolute -top-10 right-0 text-9xl font-extrabold leading-none DrukWideMediumItalic"
                  style={{
                    WebkitTextStroke: "2px red",
                    color: "white",
                  }}
                >
                  {miss}
                </div>
              </>
            )}

            <div className="text-xs text-orange-400 flex items-center gap-1 justify-end relative z-10 mt-20">
              <img
                className="w-4 h-4"
                src={require(`./assets/stopwatch.png`)}
                alt="share icon"
              />

              <span className="uppercase Kallisto_Bold">{unit}</span>
            </div>
          </div>
        </div>

        <a
          className="relative text-white px-4 py-2 text-sm flex justify-between items-center rounded-b-lg font-medium tracking-wide overflow-hidden cursor-pointer"
          style={{
            backgroundImage: `url(${personalBestBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          onClick={() => setExpanded(!expanded)}
        >
          <div className="absolute inset-0 bg-[#010058] opacity-80 pointer-events-none"></div>

          <span className="relative flex items-center gap-1 text-xl uppercase Kallisto_Bold">
            <svg
              className="w-4 h-4 transform rotate-90"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
            Personal Best:
          </span>
          <span className="relative font-bold text-white text-3xl DrukWide">
            {esaIsHitMiss === 0
              ? best.scoreDisplay
              : `${best.hit}  ${best.miss}`}
          </span>
        </a>

        {expanded && previous?.length > 0 && (
          <div className="bg-[#00001d] px-4 py-4 text-sm space-y-3 Kallisto_Bold">
            {previous.map((entry, index) => (
              <div
                key={index}
                className="flex justify-between items-center text-white font-medium"
              >
                <div className="w-[20%] uppercase text-xs font-bold">
                  {entry.date}
                </div>
                <div className="w-[50%] text-left">{entry.username}</div>

                {esaIsHitMiss === 0 ? (
                  <div className="w-[25%] text-right text-2xl font-extrabold italic DrukWide">
                    {entry.scoreDisplay}
                  </div>
                ) : (
                  <div className="w-[20%] justify-end text-right flex items-center gap-2">
                    <span
                      className="text-2xl font-extrabold italic DrukWide"
                      style={{
                        WebkitTextStroke: "2px green",
                        color: "white",
                      }}
                    >
                      {entry.hit}
                    </span>
                    <span
                      className="text-2xl font-extrabold italic DrukWide"
                      style={{
                        WebkitTextStroke: "2px red",
                        color: "white",
                      }}
                    >
                      {entry.miss}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </a>
    </>
  );
}
